/**
 * Provider pages of the services site (spec 019). Every path starts with
 * `/services`, so `ProductPathGuard` keeps them off the car and stays sites.
 */
export const PROVIDER_HOME_PATH = '/services/provider';
export const PROVIDER_LOCATIONS_PATH = '/services/provider/locations';
export const PROVIDER_WORKERS_PATH = '/services/provider/workers';
export const PROVIDER_NEW_WORKER_PATH = '/services/provider/workers/new';
export const PROVIDER_PAYOUTS_PATH = '/services/provider/payouts';
export const PROVIDER_TAX_INFO_PATH = '/services/provider/tax-info';
export const ACCEPT_WORKER_INVITE_PATH = '/accept-worker-invite';

export const workerManagePath = (carId: string) => `${PROVIDER_WORKERS_PATH}/${carId}`;
export const workerEditPath = (carId: string, step?: string) =>
  `${PROVIDER_WORKERS_PATH}/${carId}/edit${step ? `?step=${step}` : ''}`;
export const workerPricingPath = (carId: string) => `${PROVIDER_WORKERS_PATH}/${carId}/pricing`;
export const workerAccountsPath = (carId: string) => `${PROVIDER_WORKERS_PATH}/${carId}/accounts`;
